import Vue from 'vue'
import api from '@/api'

export const serviceelements = {
  namespaced: true,
  state: {
    lookups: {
      // 'contact.titleid': [],
      // 'currency': [],
      // 'billing.periodid': [],
      // 'business.statusid': [],
      // 'businessaddress.typeid': [],
      // 'businessinfo.annualrevenueid': [],
      // 'businessinfo.corporateaccountid': [],
      // 'businessinfo.dispatchpriorityid': [],
      // 'businessinfo.locationcountid': [],
      // 'businessinfo.monthlyrosid': [],
      // 'businessinfo.referralsourceid': [],
      // 'businessinfo.oemcertid': [],
      // 'businessinfo.salesrep': [],
      // 'businessinfo.distributor': [],
      // 'user.typeid': [],
      // 'discountmapping.mappingtypeid': [],
      // 'productdiscount.discounttypeid': []
    },
    pageSize: 10,
    totalLogEntries: 0,
    lookupsZeus: {},
    serviceElements: [],
    serviceElementGroups: [],
    makes: [],
    models: [],
    copyModels: [],
    serviceElementsRagRating: [],
    sortDir: '',
    orderBy: '',
    vehicleRagRatingId: '',
    ragAuditTypeList: [],
    ragAuditLog: []
  },
  getters: {
    pageSize: state => state.pageSize,
    totalLogEntries: state => state.totalLogEntries,
    lookups: state => state.lookups,
    lookupsZeus: state => state.lookupsZeus,
    scanTypes: state => state.scanTypes,
    serviceElements: state => state.serviceElements,
    serviceElementGroups: state => state.serviceElementGroups,
    makes: state => state.makes,
    models: state => state.models,
    copyModels: state => state.copyModels,
    serviceElementsRagRating: state => state.serviceElementsRagRating,
    sortDir: state => state.sortDir,
    orderBy: state => state.orderBy,
    vehicleRagRatingId: state => state.vehicleRagRatingId,
    ragAuditTypeList: state => state.ragAuditTypeList,
    ragAuditLog: state => state.ragAuditLog
  },
  actions: {
    setPageSize({ commit }, pageSize) {
      commit('SET_PAGE_SIZE', pageSize)
    },
    getLookups({ commit }, keys) {
      return new Promise((resolve, reject) => {
        api.lookups(keys, { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_LOOKUPS', { keys, data: response.data })
            resolve(response)
          })
      })
    },
    getLookupsZeus({ commit }, key) {
      return new Promise((resolve, reject) => {
        api.lookupsZeus(key, { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_LOOKUPS_ZEUS', { key, data: response.data })
            resolve(response)
          })
      })
    },
    getServiceElements({ commit }) {
      return new Promise((resolve, reject) => {
        api.serviceElements({ headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_SERVICE_ELEMENTS', response.data)
            resolve(response)
          })
      })
    },
    getServiceElementGroups({ commit }) {
      return new Promise((resolve, reject) => {
        api.getServiceElementGroups({ headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_SERVICE_ELEMENT_GROUPS', response.data)
            resolve(response)
          })
      })
    },
    getVehicleRagRatingId({ commit }, { make, model, year }) {
      return new Promise((resolve, reject) => {
        api.getVehicleRagRatingId({ make, model, year }, { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_VEHICLE_RAG_RATING_ID', response.data)
            resolve(response)
          })
      })
    },
    upsertServiceElement({ commit }, serviceElement) {
      return new Promise((resolve, reject) => {
        api.upsertServiceElement(serviceElement)
          .then(response => {
            serviceElement.id = response.data
            if (response.status === 200) {
              commit('SET_SERVICE_ELEMENT', serviceElement)
            }
            resolve(response)
          })
      })
    },
    getVehicleMakes({ commit }) {
      return new Promise((resolve, reject) => {
        api.getDistinctVehicleMakes({ headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_MAKES', response.data)
            resolve(response)
          })
      })
    },
    getVehicleModels({ commit }, { make, year, isCopy }) {
      return new Promise((resolve, reject) => {
        api.getDistinctVehicleModels({ make, year }, { headers: { 'content-type': 'application/json' } })
          .then(response => {
            if (isCopy) {
              commit('SET_COPY_MODELS', response.data)
            } else {
              commit('SET_MODELS', response.data)
            }
            resolve(response)
          })
      })
    },
    getServiceElementsRagRating({commit}, {make, model, year, orderBy, sortBy}) {
      return new Promise((resolve, reject) => {
        api.getServiceElementsRagRating({ make, model, year, orderBy, sortBy }, { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_SERVICE_ELEMENTS_RAG_RATING', response.data)
            resolve(response)
          })
      })
    },
    async getAuditLog({commit, dispatch}, searchOptions) {
      return new Promise((resolve, reject) => {
        api.getAuditLog(searchOptions)
          .then(response => {
            commit('SET_RAG_AUDIT_LOG', response.data)
            resolve(response)
          })
      })
    },
    async getRagAuditTypeList({commit}) {
      return new Promise((resolve, reject) => {
        api.getRagAuditTypeList()
          .then(response => {
            const newItem = { AuditTypeId: 0, AuditTypeName: 'All entries' }
            response.data.unshift(newItem)
            commit('SET_RAG_AUDIT_TYPE_LIST', response.data)
            resolve(response)
          })
      })
    },
    async updateRagRating({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        api.updateRagRating(data)
          .then(response => {
            resolve(response)
          })
      })
    },
    async bulkCopyRagRating({ commit, dispatch }, {bulkCopyParams}) {
      return new Promise((resolve, reject) => {
        api.bulkCopyRagRating({bulkCopyParams})
          .then(response => {
            resolve(response)
          })
      })
    },
    async copyRagRating({ commit, dispatch }, {sourceVehicleId, targetVehicleId}) {
      return new Promise((resolve, reject) => {
        api.copyRagRating({sourceVehicleId, targetVehicleId})
          .then(response => {
            resolve(response)
          })
      })
    },
    async audit({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        api.audit(data)
          .then(response => {
            resolve(response)
          })
      })
    },
    setSortDir({
      commit
    }, sortDir) {
      commit('SET_SORT_DIR', sortDir)
    },
    setOrderBy({
      commit
    }, orderBy) {
      commit('SET_ORDER_BY', orderBy)
    }
  },
  mutations: {
    SET_PAGE_SIZE(state, value) {
      if (value !== undefined && value !== null) {
        state.pageSize = parseInt(value)
      }
    },
    SET_LOOKUPS(state, { keys, data }) {
      if (data !== undefined && data !== null) {
        if (typeof keys === 'object') {
          if (data !== '') {
            keys.forEach(x => {
              Vue.set(state.lookups, x, data.filter(l => l.key === x))
            })
          }
        } else {
          Vue.set(state.lookups, keys, data)
        }
      }
    },
    SET_LOOKUPS_ZEUS(state, { key, data }) {
      Vue.set(state.lookupsZeus, key, data)
    },
    SET_SERVICE_ELEMENTS(state, data) {
      state.serviceElements = data
    },
    SET_SERVICE_ELEMENT_GROUPS(state, data) {
      state.serviceElementGroups = data
    },
    SET_SERVICE_ELEMENT(state, data) {
      var idx = state.serviceElements.findIndex(i => i.id === data.id)
      if (idx !== -1) {
        if (!data.isActive) {
          state.serviceElements.splice(idx, 1)
        } else {
          state.serviceElements[idx].name = data.name
          state.serviceElements[idx].serviceElementGroupId = data.serviceElementGroupId
          state.serviceElements[idx].serviceElementGroupName = data.serviceElementGroupName
          state.serviceElements[idx].isActive = data.isActive
        }
      } else {
        const lookup = {
          id: data.id,
          name: data.name,
          serviceElementGroupId: data.serviceElementGroupId,
          serviceElementGroupName: data.serviceElementGroupName
        }
        state.serviceElements.push(lookup)
      }
    },
    SET_LOOKUP(state, lookup) {
      if (lookup.isActive) {
        state.lookups[lookup.key].push(lookup)
      } else {
        var index = state.lookups[lookup.key].findIndex(i => i.id === lookup.id)
        state.lookups[lookup.key].splice(index, 1)
      }
    },
    SET_MAKES(state, data) {
      state.makes = data
    },
    SET_MODELS(state, data) {
      state.models = data
    },
    SET_COPY_MODELS(state, data) {
      state.copyModels = data
    },
    SET_SERVICE_ELEMENTS_RAG_RATING(state, data) {
      state.serviceElementsRagRating = data
    },
    SET_SORT_DIR(state, text) {
      if (text !== undefined && text !== null) {
        state.sortDir = text
      }
    },
    SET_ORDER_BY(state, text) {
      if (text !== undefined && text !== null) {
        state.orderBy = text
      }
	},
    SET_VEHICLE_RAG_RATING_ID(state, data) {
      state.vehicleRagRatingId = data
    },
    SET_RAG_AUDIT_TYPE_LIST(state, data) {
      state.ragAuditTypeList = data
    },
    SET_RAG_AUDIT_LOG(state, data) {
      state.totalLogEntries = 0
      state.ragAuditLog = []
      if (data !== undefined && data !== null) {
        if (data.length > 0) {
          state.totalLogEntries = data[0].TotalItems
          state.ragAuditLog = data
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/serviceelements/index.js